import React, { useEffect, useMemo, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {
  success, error, loading,
  Updateloading,
} from "../common/helpers/toastify";
import Select from "react-select";
import { poscustomorder_head } from "../../components/common/Tablehead";
import CheckoutBlank from "../checkout/checkoutBlank";
import "./custom.scss";
import { _Api } from "../common/api/_call";
import { store } from '../../source/index'
import { useSelector } from 'react-redux';
import CustomerSearchModal from "../common/module/customerSearch";
import TableColumnModal from "../../components/common/modules/tableColumn";
import { toFormatPrice, toUnformatPrice } from '../common/helpers/function';
import CheckoutSell from '../checkout/checkoutSell'
import CheckoutPayment from '../checkout/checkoutPayment'
import { Customsubtable } from "./subtable/Customsubtable";
import { useTranslation } from 'react-i18next';
import { customOrder_status } from '../../components/common/helpers/status_class';
import ConfirmationModel from '../../admin/common/modules/confirmationmodel'

const parseOrderDate = (value) => {
  if (!value) return null;
  const parsed = moment(
    value,
    ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "YYYY-MM-DD", "DD-MM-YYYY"],
    true
  );
  if (parsed.isValid()) return parsed.valueOf();
  const fallback = moment(value);
  return fallback.isValid() ? fallback.valueOf() : null;
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(num) ? null : num;
};

// Sort accessor per column index of poscustomorder_head.
const SORT_ACCESSORS = [
  null,
  null,
  (r) => parseOrderDate(r?.transaction_date),
  (r) => r?.order_no,
  (r) => r?.SKU,
  (r) => r?.customer,
  (r) => toNumber(r?.Qty),
  (r) => toNumber(r?.labour),
  (r) => toNumber(r?.amount),
  (r) => toNumber(r?.payment),
  (r) => toNumber(r?.balance_due),
  (r) => toNumber(r?.status),
  (r) => parseOrderDate(r?.delivery_date),
  (r) => r?.location_name,
];

const CustomOrderDelivered = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  let reduxdata = store.getState()
  let OrgSettings = reduxdata?.app?.posorganisation_settings
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [newcolumndata, setnewcolumndata] = useState(poscustomorder_head);
  const customer = useSelector((state) => state.app.customer);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [orderlist, setOrderlist] = useState();
  const [sortConfig, setSortConfig] = useState({ index: null, direction: "asc" });
  const [, setdeletestatus] = useState(false)
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const [orderid, setOrderid] = useState('');
  const [showcheckout, setShowcheckout] = useState('blank')
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [excuteTable, setexcuteTable] = useState(false);
  const [searchlist, setSearchlist] = useState();
  const [customerid, setCustomerid] = useState();
  const [statement, setStatement] = useState("");
  const [currentIdToChange, setCurrentIdToChange] = useState({})
  const searchDebounceRef = useRef(null);

  // Column settings come from the API; only trust them when they match this table's columns.
  const columnSettings =
    Array.isArray(newcolumndata) && newcolumndata.length === poscustomorder_head.length
      ? newcolumndata
      : poscustomorder_head;
  const isColumnVisible = (index) => columnSettings[index]?.status !== false;
  const visibleColumnCount = poscustomorder_head.filter((_, index) => isColumnVisible(index)).length;

  const handleSort = (index) => {
    setSortConfig((prev) =>
      prev.index === index
        ? { index, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { index, direction: "asc" }
    );
  };

  const sortedOrderlist = useMemo(() => {
    const list = Array.isArray(orderlist) ? orderlist : [];
    const accessor = SORT_ACCESSORS[sortConfig.index];
    if (!accessor) return list;
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null || av === "") return 1;
      if (bv === undefined || bv === null || bv === "") return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [orderlist, sortConfig]);

  const sumOf = (field) =>
    orderlist
      ? orderlist.reduce((total, val) => total + toUnformatPrice(val?.[field]), 0)
      : "";

  const colorStyles = {
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: data.color
      };
    }
  };

  const changeStatus = (index, value, po_order_id, statusid) => {
    setStatement("Change Status");
    setCurrentIdToChange({status: statusid, id: po_order_id})
    // setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
    document.querySelector("#status_query_select").click();
  };
  useEffect(() => {
    callcolumns();
  }, []);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_pos_customorderdelivered",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const Getcustomeorder = async () => {
    setexcuteTable(false);
    document.querySelectorAll(".table_btn_expand_col").forEach((expand_col) => expand_col.classList.remove("rotate-90"));
    try {
      const postdata = {
        "customer_id": customer?.id,
        "date": TransactionDate,
        'order_type': 'custom_order'
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/getOrderList`);
      if (res.code === 200) {
        setexcuteTable(true);
        setOrderlist(res?.data);
      }
    }
    catch (err) {
      console.log(err, 'err');
    }
  }
  useEffect(() => {
    if (customer?.id) {
      Getcustomeorder();
    } else {
      Getcustomeorder();
    }
    // eslint-disable-next-line
  }, [customer?.id, TransactionDate]);

  const setSubTablecustom = async (order_id) => {
    var e = document.querySelector("#table-btn_" + order_id);
    if (!e) return;
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      setOrderlist((prev) => prev.map((item) => item.order_id === order_id ? { ...item, subTabledata: null } : item));
    } else {
      classList_.add("rotate-90");
      const postdata = {
        "Order_id": order_id
      };
      let prioritydata = await _Api(postdata, `api/v1/POS/customOrder/getSkuByOrderList`);
      var html_ = Customsubtable(prioritydata, order_id, t);
      // The sub-table renders right after its row, so it follows the row when sorting.
      setOrderlist((prev) => prev.map((item) => item.order_id === order_id ? { ...item, subTabledata: html_ } : item));
    }
  }
  const GetCartdetailorder = async () => {
    try {
      const postdata = {
        "order_id": orderid,
        'order_type': 'custom_order',
        "by_custom_order": true
      }
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`)
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        setShowcheckout('sell');
      } else {
        navigate('/app/pos/custom/customOrderDelivered')
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const getsearchlist = async (value) => {
    value = value ? value.trim() : "";
    if (!value) {
      setSearchlist([]);
      return;
    }
    try {
      const posdata = {
        "search": value,
        "type": "inventory",
        "from": 'createYourOwn'
      }
      let res = await _Api(posdata, `api/v1/POS/customOrder/skuNameBySearch`)
      if (res.code === 200) {
        setSearchlist(res?.data);
      } else {
        setSearchlist([]);
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const AddtoCart = async (product_id) => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    const GetloadingID = loading();
    try {
      const postdata = {
        "product_id": product_id,
        "type": 'inventory',
        "customer_id": customer?.id,
        "sales_person_id": saleperson?.value,
        "order_type": "custom_order"
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/addItemToCart`);
      if (res.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Add to Cart!!"));
        setShowcheckout('sell');
        setsearchproductstatus(true)

      } else {
        Updateloading(t, GetloadingID, t("This Product Already in cart!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  }
  const getprintcustomorder = async () => {
    if (!customer?.id && !customerid) {
      error(t("Customer is Requried!!"));
      return;
    }
    let GetloadingID = loading()
    try {
      const postdata = {
        "customer_id": customerid ? customerid : customer?.id
      }
      let res = await _Api(postdata, `api/v1/POS/reports/print/customOrderOutstanding`)

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a')
          exportLinkElement.hidden = true
          exportLinkElement.download = res?.name ? res?.name : 'report.pdf'
          exportLinkElement.href = res?.link
          exportLinkElement.text = 'downloading...'
          exportLinkElement.setAttribute('target', '_blank')
          document.body.appendChild(exportLinkElement)
          exportLinkElement.click()
          exportLinkElement.remove()
          Updateloading(t, GetloadingID, t('download successfully'))
        }, 50)
      }
      if (res.code === 400) {
        Updateloading(t, GetloadingID, res?.messgae, t('error'))
      }


    } catch (err) {
      console.log(err, 'err')
      Updateloading(t, GetloadingID, err, t('error'))
    }
  }
  const selectedproduct = (event, id, ststus) => {
    if (event.target.checked) {
      if (ststus === 5) {
        setOrderid(id)
      } else {
        setOrderid("")
      }
    } else {
      setOrderid("")
    }
  }

  const handleChange = async() =>{
    console.log("handle Change is here", currentIdToChange);
    try{
      let postdata = {
       status : currentIdToChange.status === 1 || currentIdToChange.status === 0 ? 9 : 1 ,
       id : currentIdToChange.id
      }
      console.log(postdata, "Check post data")
      // http://localhost:3000/api/v1/pos/customOrder/edit-pos-status
      let res = await _Api(postdata, `api/v1/pos/customOrder/edit-pos-status`)
      if (res.code === 200) {
        success("Successfully updated!")
        console.log("checkout result")
        Getcustomeorder();
      }
    }catch(err){
      console.log(err, "error")
    }
  }

  const handleClose = () =>{
    console.log(currentIdToChange, "handle Close");
  }
  
  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);

  return (
    <>
      <div className="main-body custom-order-table">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className='com-data-area'>
              <div className="catalog-area-header-area detail-area-header">
                <div className="catalog-area-header-area-control">
                  <div className="catalog-area-header-area-control-left page-back-btn-inside">
                    <Link to="/app/pos/custom/custom"><img className='page-back-btn-inside-img' src={base_assets + "/images/icons/arrow-left.png"} alt="back" /></Link>
                    <h1 className="heading">{t("Custom Order")}</h1>
                  </div>

                  <div className="catalog-area-header-area-control-right">
                    <div className="com-search-area">
                      <button className="com-search-area-left-img scan-img"><img src={base_assets + "/images/pos/icons/scan-icon.png"} alt="" /></button>
                      <input type="text" 
                      // onChange={(e) => { getsearchlist(e.target.value) }} 
                      onChange={(e) => {
                        const value = e.target.value;
                        if (searchDebounceRef.current) {
                          clearTimeout(searchDebounceRef.current);
                        }
                        searchDebounceRef.current = setTimeout(() => {
                          getsearchlist(value);
                        }, 300);
                      }} 
                      placeholder={t("Scan barcode, Search SKU")} id="dropdownMenuButton1" data-bs-toggle="dropdown" autoComplete="off" />
                      <ul className="dropdown-menu custom-search-dropdown" aria-labelledby="dropdownMenuButton1">
                        {searchlist?.length ? searchlist.map((result, key) => {
                          return (
                            <li key={key}>
                              <Link className="dropdown-item pos-search-result-item" onClick={() => AddtoCart(result?._id)}>
                                <div className="pos-search-result-thumb">
                                  {result?.main_image ? (
                                    <img
                                      src={result.main_image}
                                      alt=""
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                      }}
                                    />
                                  ) : null}
                                </div>
                                <div className="pos-search-result-text">
                                  <div className="pos-search-result-name">{result?.name}</div>
                                  <div className="pos-search-result-meta">
                                    {result?.SKU}{result?.stock_id ? ' - ' + result?.stock_id : ''}
                                  </div>
                                </div>
                              </Link>
                            </li>
                          );
                        }) : ''}
                      </ul>
                      <button className="btn-style lh-0">
                        <img className="com-search-area-img" src={base_assets + "/images/pos/icons/magnifying-glass.png"} alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='com-data-area-header delivered-header'>
                <div className='delivered-header-left custom-order-search'>
                  <CustomerSearchModal ></CustomerSearchModal>
                  <ul className='graph-indicator ms-4 text-nowrap'>
                    <li className='graph-indicator-single'>
                      <span className='graph-indicator-single-color danger-bg'></span>
                      <label className='graph-indicator-single-label'>{t("Create your own")}</label>
                    </li>
                    <li className='graph-indicator-single'>
                      <span className='graph-indicator-single-color status-pending'></span>
                      <label className='graph-indicator-single-label'>{t("Mix & Match")}</label>
                    </li>
                  </ul>
                </div>
                <div className='customer-inner-data-payment-table-top-bar-right placeholder-up-input-date date ms-auto me-2'>
                  <DatePicker
                    className="placeholder-up-input-field"
                    selected={TransactionDate}
                    onChange={(input) => setTransactionDate(input)}
                    name="TransactionDate"
                    dateFormat={OrgSettings?.date_picker}
                    autoComplete='none'
                  />
                  <img
                    className="placeholder-up-input-field-calender"
                    src={base_assets + "images/icons/calendar-green.svg"}
                    alt=""
                  />
                </div>
                <div className=" dropdown Dailysalereport-content-area-header-leftdropdown">
                  <button className='btn-style' type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><img src={base_assets + 'images/icons/ellipsis-circular.png'} alt="" /></button>
                  <ul className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li onClick={() => getprintcustomorder()}>
                      <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                        <div className="dropdown-menu-img">
                          <img src={base_assets + "images/pos/report/print-icon.png"} alt="" />
                        </div>
                        {t("Print")}</Link>
                    </li>
                    <li>
                      <Link className="dropdown-item  Dailysalereport-content-area-header-leftdropdown-menu-item"
                        to="#">
                        <div className="dropdown-menu-img">
                          <img src={base_assets + "images/pos/report/export-icon.png"} alt="" />
                        </div>
                        {t("Export")}</Link>
                    </li>
                    <li data-bs-toggle="modal" data-bs-target="#columnModal">
                      <Link className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item" to="#">
                        <div className="dropdown-menu-img">
                          <img src={base_assets + "images/icons/column-icon.png"} alt="" />
                        </div>
                        {t("Column")}</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="com-data-area-inner">

                <div
                  className="main-body-main-table-wrap customOrderlist"
                  id="table-scroll"
                  // height: auto overrides the fill-the-area height from posstyle.scss, so the
                  // horizontal scrollbar sits right under the rows instead of at the page bottom.
                  style={{ height: "auto", maxHeight: "65vh", overflow: "auto" }}
                >
                  <table id='com-data-area_table' className="common-table first-row-gray w-100">
                    <thead>
                      <tr>
                        {poscustomorder_head.map((col, index) => {
                          if (!isColumnVisible(index)) return null;
                          const sortable = Boolean(col?.sort) && Boolean(SORT_ACCESSORS[index]);
                          const active = sortConfig.index === index;
                          return (
                            <th
                              key={index}
                              className={col?.class}
                              onClick={sortable ? () => handleSort(index) : undefined}
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                background: "#fff",
                                cursor: sortable ? "pointer" : undefined,
                              }}
                            >
                              {t(col?.lable)}
                              {sortable ? (
                                <div className="up-down-arrow-btn">
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-forward" +
                                      (active && sortConfig.direction === "desc" ? "" : " active")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow.png"}
                                    alt=""
                                  />
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-reverse" +
                                      (active && sortConfig.direction === "desc" ? " active" : "")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow-reverse.png"}
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedOrderlist.length ? sortedOrderlist.map((result, key) => {
                        var po_status_class_val = customOrder_status(
                          result?.status
                        );
                        var optionData = (result.status === 1 || result.status === 0) ? [
                          { label: "Cancel Order", value: "Cancel Order", color: "#df5454" }
                        ] : [
                          { label: "Open Order", value: "Open Order", color: "#F9BC44" }];
                        var valueofstatus = result?.status === 1 || result?.status === 0 ?
                          { label: "Open Order", value: "Open Order", color: "#F9BC44" }
                          : result?.status === 2 ?
                            { label: "Production", value: "Production", color: "#FFC27B" }
                            : result?.status === 3 ?
                              { label: "MFG Stock", value: "MFG Stock", color: "#72D3CE" }
                              : result?.status === 4 ?
                                { label: "transit", value: "transit", color: "#97BFD9" }
                                : result?.status === 5 ?
                                  { label: "Stock", value: "Stock", color: "#81C5F7" }
                                  : result?.status === 6 ?
                                    { label: "Sold Out", value: "Sold Out", color: "#F08585" }
                                    : result?.status === 9 ?
                                      { label: "Cancel Order", value: "Cancel Order", color: "#df5454" }
                                      : '';

                        const cells = [
                          <td key="0" className="row-check">
                            <div className="com-check radio">
                              <input type="radio"
                                onClick={(e) => { setCustomerid(result?.customer_id) }}
                                onChange={(e) => selectedproduct(e, result?.order_id, result?.status)}
                                name='customchack'
                                id={result?.order_id}
                              />
                              <label htmlFor={result?.order_id} className="com-check-label" />
                            </div>
                          </td>,
                          <td key="1">{key + 1}</td>,
                          <td key="2">{result?.transaction_date}</td>,
                          <td key="3" className='link-color'>{result?.order_no}</td>,
                          <td key="4" className='sku-col table_btn_expand_col'
                            onClick={() => setSubTablecustom(result?.order_id)}
                            id={"table-btn_" + result?.order_id}>  <img
                              className="sku-col-arrow cursor-pointer"
                              src={
                                base_assets +
                                "/images/icons/right_green_button.png"
                              }
                              alt=""
                            />
                            {result?.SKU}</td>,
                          <td key="5" className='danger-text'>{result?.customer}</td>,
                          <td key="6">{result?.Qty}</td>,
                          <td key="7">{toFormatPrice(result?.labour, { addSymbol: true })}</td>,
                          <td key="8">{toFormatPrice(result?.amount, { addSymbol: true })}</td>,
                          <td key="9" className='main-green-text'>{toFormatPrice(result?.payment, { addSymbol: true })}</td>,
                          <td key="10" className='danger-text'>{toFormatPrice(result?.balance_due, { addSymbol: true })}</td>,
                          <td key="11">
                            {result?.status === 1 || result?.status === 9 || result?.status === 0 ?
                              <div
                                className={
                                  "dropdown status-dropdown status-dropdown-select status-tab " +
                                  po_status_class_val
                                }
                              >
                                <Select
                                  options={optionData ? optionData : []}
                                  value={valueofstatus}
                                  onChange={(event) =>
                                    changeStatus(key, event, result.order_id, result.status)
                                  }
                                  classNamePrefix="status-dropdown-select"
                                  styles={colorStyles}
                                  getOptionLabel={(e) => (
                                    <div className="">
                                      {e.label}
                                    </div>
                                  )}
                                  isSearchable={false}
                                />
                              </div>
                              :
                              result?.status === 2 ?
                                <label className='status-tab production-col'>{t("Production")}</label>
                                :
                                result?.status === 3 ?
                                  <label className='status-tab mgf-stock-bg'>{t("MFG Stock")}</label>
                                  :
                                  result?.status === 4 ?
                                    <label className='status-tab transit-bg-col'>{t("transit")} </label>
                                    :
                                    result?.status === 5 ?
                                      <label className='status-tab stoke-bg'>{t("Stock")}</label>
                                      :
                                      result?.status === 6 ?
                                        <label className='status-tab sol-out-col'>{t("Sold Out")} </label>
                                        :
                                        result?.status === 9 ?
                                          <label className='status-tab gray-tab'>{t("Cancel Order")}</label>
                                          : ''
                            }
                          </td>,
                          <td key="12" className='danger-text'>{result?.delivery_date}</td>,
                          <td key="13">{result?.location_name}</td>,
                        ];

                        return (
                          <React.Fragment key={result?.order_id ?? key}>
                            <tr className={result?.status_type === "custom_order" ? 'tr-left-red-border' : "tr-left-yellow-border"}
                              id={`common-main-table-wrap-${result?.order_id}`}>
                              {cells.filter((_, index) => isColumnVisible(index))}
                            </tr>
                            {excuteTable && result?.subTabledata ? result.subTabledata : null}
                          </React.Fragment>
                        );
                      }) : (
                        <tr>
                          <td colSpan={visibleColumnCount} className="text-center">
                            {t("No Data Available In Table")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot>
                      <tr>
                        {[
                          <td key="0"></td>,
                          <td key="1"></td>,
                          <td key="2"></td>,
                          <td key="3"></td>,
                          <td key="4"></td>,
                          <td key="5"></td>,
                          <td key="6">{sumOf("Qty")}</td>,
                          <td key="7">{toFormatPrice(sumOf("labour"), { addSymbol: true })}</td>,
                          <td key="8">{toFormatPrice(sumOf("amount"), { addSymbol: true })}</td>,
                          <td key="9" className='main-green-text'>{toFormatPrice(sumOf("payment"), { addSymbol: true })}</td>,
                          <td key="10" className='danger-text'>{toFormatPrice(sumOf("balance_due"), { addSymbol: true })}</td>,
                          <td key="11"></td>,
                          <td key="12"></td>,
                          <td key="13"></td>,
                        ]
                          .filter((_, index) => isColumnVisible(index))
                          .map((cell) =>
                            // Keep the totals visible at the bottom while the list scrolls.
                            React.cloneElement(cell, {
                              style: { position: "sticky", bottom: 0, zIndex: 1, background: "#fff" },
                            })
                          )}
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className='com-data-area-footer-btn'>
                  <button onClick={() => { GetCartdetailorder(); }}
                    className={orderid !== '' && showcheckout === 'blank' ? 'com-btn ms-auto' : 'com-btn ms-auto btn-disabled'}>
                    {t("Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === 'sell' ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setdeletestatus={setdeletestatus}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                ordertype={"pos_order"}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
                by_custom_order={true}
                order_id={orderid ? orderid : ''}
              />
            ) : showcheckout === 'payment' ? (
              <CheckoutPayment UpdatedCart={UpdatedCart} setShowcheckout={setShowcheckout} order_id={orderid ? orderid : ''} by_custom_order={true} />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
      <TableColumnModal tablehead={poscustomorder_head} tblName={"tbl_pos_customorderdelivered"} setnewcolumndata={setnewcolumndata}
        calldatatable={Getcustomeorder}></TableColumnModal>
         <ConfirmationModel
          statement={statement}
          handler_submit={statement === 'Change Status' ? handleChange : handleClose}
          handler_dismiss={handleClose}
        ></ConfirmationModel>
        <button
          className="d-none"
          data-bs-toggle="modal"
          data-bs-target="#createPurchaseModal"
          id="status_query_select"
        ></button>
    </>
  )
}

export default CustomOrderDelivered;